import React from "react";
import "./nestedReply.css";
import moment from "moment";
import { IP } from "../../../internalServer"
import { Tooltip } from "@mui/material";
import { shortenParagraph } from "../../../utils/Engagement";

const NestedReply = ({ parentReply }) => {

  return (
    <>
      <>
        {/*nested Reply ui*/}

        <div className=" p-2  gap-1 flex-wrap nested_reply_box ">
          <div className=" gap-1 d-flex align-items-center">
            {
              parentReply.createdBy?.role === "Teacher" ?
                <img
                  src={
                    parentReply.createdBy?.profile_picture
                      ? IP + parentReply.createdBy?.profile_picture.replace(/^\./, "")
                      : parentReply.createdBy?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : parentReply.createdBy?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer" }}
                  key={parentReply.createdBy?.avatarProfile}
                  onError={(e) => {
                    if (parentReply.createdBy?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg"
                    } else if (parentReply.createdBy?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                /> : parentReply.createdBy?.role === "Student" ? <img
                  src={
                    parentReply.createdBy?.profile_picture
                      ? IP + parentReply.createdBy?.profile_picture.replace(/^\./, "")
                      : parentReply.createdBy.gender === "M"
                        ? parentReply.createdBy?.avatarProfile ? '/images/Boys/' + parentReply.createdBy?.avatarProfile + '.webp'
                          : "/images/Student_boy_pic.png"
                        : parentReply.createdBy?.gender === "F"
                          ? parentReply.createdBy?.avatarProfile ? '/images/Girls/' + parentReply.createdBy?.avatarProfile + '.webp'
                            : "/images/Student_girl_pic.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer" }}
                  key={parentReply.createdBy?.avatarProfile}
                  onError={(e) => {
                    if (parentReply.createdBy?.gender === "M") {
                      e.target.src = parentReply.createdBy?.avatarProfile ? '/images/Boys/' + parentReply.createdBy?.avatarProfile + '.webp' : "/images/Student_boy_pic.png"
                    } else if (parentReply.createdBy?.gender === "F") {
                      e.target.src = parentReply.createdBy?.avatarProfile ? '/images/Girls/' + parentReply.createdBy?.avatarProfile + '.webp' : "/images/Student_girl_pic.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                /> : <img style={{ width: "25px", height: "25px", borderRadius: "50%", cursor: "pointer", marginRight: "10px" }} src="/images/default image.png" alt="" />
            }
            <span className=" nested_user_name">
              {parentReply.createdBy.name}
            </span>
            <span
              className="badge bg-secondary "
              style={{ fontSize: "12px", maxWidth: "fit-content" }}>
              {moment(parentReply.created_at).calendar({
                sameDay: "[Today]",
                lastDay: "[Yesterday]",
                lastWeek: "DD MMM ",
                sameElse: "DD MMM",
              })}{" "}
              |{"  "}
              {moment(parentReply.created_at).calendar({
                sameDay: "hh:mm A",
                lastDay: "hh:mm A",
                lastWeek: "hh:mm A ",
                sameElse: "hh:mm A",
              })}
            </span>
          </div>
          <p
            className="w-[96%] comments-text ml-4 mt-2 mb-2 poppins-semibold"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {parentReply.reply}
          </p>
        </div>
      </>
    </>
  );
};

export default NestedReply;
